import React, { useState, useEffect } from 'react';
import '../../App.css';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import TalentCalendar from '../TalentCalendar';
import closeButton from '../../images/close.svg';
import calendarIcon from '../../images/calendar.svg';
import selectIcon from '../../images/select.svg';
import { bookingService, talentService, companyService, locationService } from '../../api/apiService';

function CreateDummyOrder() {
  const [skipEffect, setSkipEffect] = useState(false);
  const navigate = useNavigate();
  const [similarBookings, setSimilarBookings] = useState([]);
  const [search, setSearch] = useState(""); // New state for search term
  const [sortOrder, setSortOrder] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalentdet, setSelectedTalentdet] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [selectedTalentName, setSelectedTalentName] = useState(null);
  const [selectedTalentEmail, setSelectedTalentEmail] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');
  const [bookingDetails, setBookingDetails] = useState(null);
  const [selectedCostCenter, setSelecedCostcenter] = useState(null);
  const [selectedCostCentertwo, setSelecedCostcentertwo] = useState(null);
  const [editingbokkingTalentid, setEditingbookingTalentid] = useState('');
  const [editingbookingCompany, setEditingbookingcompany] = useState('');
  const [loading, setLoading] = useState(true);
  const [kpi, setKpi] = useState('KPI');
  const [set, setSet] = useState('SET');
  const [position, setPosition] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [selectedFunction, setSelectedFunction] = useState();
  const location = useLocation();
  const bookingId = new URLSearchParams(location.search).get('bookingId');
  const [groupID, setGroupID] = useState(new URLSearchParams(location.search).get('group'));
  const [times, setTimes] = useState('');
  const [groupColor, setgroupColor] = useState('');
  const [client, setClient] = useState('SetCast- 1. Option');
  const [bookingoption, setbookingoption] = useState();
  const [startTime, setStartTime]= useState();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState(new URLSearchParams(location.search).get('sonstige'));
  const [endTime, setEndTime]= useState();
  const [locations, setLocations] = useState([]);
  const [selectLocations, setSelectedLocations] = useState([]);
  const [segment, setSegment] = useState(new URLSearchParams(location.search).get('segment'));
  const [range, setRange] = useState(new URLSearchParams(location.search).get('range'));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const positions = [
    { value: 'HM', label: 'Hair & Make-Up' },
    { value: 'AD', label: 'Art Direktion' },
    { value: 'Foto', label: 'Foto' },
    { value: 'foto-assistent', label: 'Foto Assist' },
    { value: 'video', label: 'Video' },
    { value: 'digi-op', label: 'Digi-OP' },
    { value: 'styling', label: 'Styling' },
    { value: 'styling-assistent', label: 'Styling Assist' },
    { value: "LOGISTIK / WARENAUFBEREITUNG", label: "LOGISTIK / WARENAUFBEREITUNG" },
    { value: "PRODUCER", label: "PRODUCER" },
    { value: "Art Buying", label: "Art Buying" }, 
    { value: "Account Management", label: "Account Management" }, 
    { value: "AI Content Production", label: "AI Content Production" }
  ];

  const onmodel = [
    { value: 'onmodel', label: 'on Model' },
    { value: 'Produkt', label: 'on Produkt' },
  ];

  const bookingoptions = [
    { value: '1. Option ', label: '1. Option ' },
    { value: '2. Option ', label: '2. Option ' },
  ];

  const [selectedOption, setSelectedOption] = React.useState("neworder");
  const [selectedPosition, setselectedPosition] = React.useState(null);
  
  const handleOptionChange = selectedOption => {
    setSelectedOption(selectedOption);
  }

  const handlebookingOption = selectedOption => {
    setbookingoption(selectedOption);
  }

  const handlePostionchange = selectedPosition => {
    setselectedPosition(selectedPosition);
  }

  const handleClientChange = selectedOption => {
    setClient(selectedOption);
  }

  const handlesetSelect = (selectedOption) => {
    setSet(selectedOption);
  };
  
  const [clientValid, setClientValid] = useState(true);
  const [positionValid, setPositionValid] = useState(true);
  const [optionsValid, setOptionsValid] = useState(true);

  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: 'none',
    }),
    control: (base) => ({
      ...base,
      width: '100%',
      borderColor: 'black',
      borderWidth: '1px',
      boxShadow: 'none',
      margin: '0 0 10px 0',
      borderRadius: '0px',
      color: 'black',
      fontWeight: "700",
      height: '50px',
      textTransform: 'uppercase',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700"
    }),
    input: (provided) => ({
      ...provided,
      color: 'black', // Your color
      fontWeight: "700",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'black' : 'inherit',
      '&:hover': { backgroundColor: state.isSelected ? 'black' : '#f7f7f7' }
    }),
  };

  const constcenter1 = [
    { id: '714', label: 'Post Outsourcing', accountNumber: '70175', value: '714' },
    { id: '715', label: 'Virtual Production-Operator', accountNumber: '70155', value: '715' },
    { id: '716', label: 'Videograf', accountNumber: '70145', value: '716' },
    { id: '717', label: 'Foto Still', accountNumber: '70110', value: '717' },
    { id: '718', label: 'Styling Still', accountNumber: '70111', value: '718' },
    { id: '719', label: 'Foto Life', accountNumber: '70120', value: '719' },
    { id: '720', label: 'Styling Life', accountNumber: '70121', value: '720' },
    { id: '721', label: 'Foto-Assistenz Life', accountNumber: '70122', value: '721' },
    { id: '722', label: 'Models', accountNumber: '70124', value: '722' },
    { id: '723', label: 'Hair & Make up', accountNumber: '70130', value: '723' },
    { id: '724', label: 'Art Direction', accountNumber: '70160', value: '724' },
    { id: '725', label: 'Post Production', accountNumber: '70170', value: '725' },
    { id: '726', label: 'Text', accountNumber: '70180', value: '726' },
    { id: '727', label: 'Sonstiges Produktion', accountNumber: '70190', value: '727' },
    { id: '728', label: 'Verpflegung Shooting', accountNumber: '70193', value: '728' },
    { id: '729', label: 'Producing', accountNumber: '70230', value: '729' },
    { id: '730', label: 'Modelbooking', accountNumber: '70240', value: '730' },
    { id: '731', label: 'Art Buying', accountNumber: '70250', value: '731' },
    { id: '732', label: 'Logistik/Warenaufbereitung', accountNumber: '70260', value: '732' },
    { id: '733', label: 'Technical Support', accountNumber: '70270', value: '733' },
    { id: '734', label: 'Setbau', accountNumber: '70280', value: '734' },
    { id: '735', label: 'Account Management', accountNumber: '70320', value: '735' },
    { id: '736', label: 'Sales/Marketing', accountNumber: '70440', value: '736' },
    { id: '737', label: 'IT/Technik', accountNumber: '70450', value: '737' },
    { id: '739', label: 'Still Operator', accountNumber: '70115', value: '739' },
    { id: "845", label: "Digital Operator", accountNumber: "70150", value: "845" },
    {
      id: "860",
      label: "AI Content Production",
      accountNumber: "70199",
      value: "860",
    },

  ];
  
  const constcenter2 = [
    { id: '738', label: 'Kunden-übergreifend / Sonstiges', accountNumber: '709005', value: '738' },
    { id: '740', label: 'S.Oliver Produktfoto', accountNumber: '700021', value: '740' },
    { id: '741', label: 'Comma Produktfoto', accountNumber: '700031', value: '741' },
    { id: '742', label: 'Liebeskind Produktfoto', accountNumber: '700041', value: '742' },
    { id: '743', label: 'Görtz Produktfoto', accountNumber: '700051', value: '743' },
    { id: '744', label: 'PUMA Produktfoto', accountNumber: '700061', value: '744' },
    { id: '745', label: 'PUMA Kampagne', accountNumber: '700062', value: '745' },
    { id: '746', label: 'TomTailor Produktfoto', accountNumber: '700071', value: '746' },
    { id: '747', label: 'TomTailor Kamagne', accountNumber: '700072', value: '747' },
    { id: '748', label: 'BonPrix Produktfoto', accountNumber: '700091', value: '748' },
    { id: '749', label: 'HFG Produktfoto', accountNumber: '700101', value: '749' },
    { id: '750', label: 'HFG Kampagne', accountNumber: '700102', value: '750' },
    { id: '751', label: 'Juvia Produktfoto', accountNumber: '700111', value: '751' },
    { id: '752', label: 'HugoBoss Produktfoto', accountNumber: '700121', value: '752' },
    { id: '753', label: 'HugoBoss Kampagne', accountNumber: '700122', value: '753' },
    { id: '754', label: 'Bogner Produktfoto', accountNumber: '700601', value: '754' },
    { id: '755', label: 'Bogner Kampagne', accountNumber: '700602', value: '755' },
    { id: '756', label: 'Heine Produktfoto', accountNumber: '700621', value: '756' },
    { id: '757', label: 'WittWeiden Produktfoto', accountNumber: '705071', value: '757' },
    { id: '758', label: 'Zalando EPS Produktfoto', accountNumber: '705141', value: '758' },
    { id: '759', label: 'Zalando EPS Kampagne', accountNumber: '705142', value: '759' },
    { id: '760', label: 'ToryBurch Produktfoto', accountNumber: '705171', value: '760' },
    { id: '761', label: 'Falke Produktfoto', accountNumber: '705181', value: '761' },
    { id: '762', label: 'Zalando RPDP Produktfoto', accountNumber: '705221', value: '762' },
    { id: '763', label: 'Sonstige Kleinkunden Produktfoto', accountNumber: '707991', value: '763' },
    { id: '766', label: 'PUMA Virtual Production', accountNumber: '700066', value: '766' },
    { id: '767', label: 'C&A Produktfoto', accountNumber: '703421', value: '767' },
    { id: '768', label: 'C&A Kampagne', accountNumber: '703422', value: '768' },
    { id: '769', label: 'C&A Virtual Production', accountNumber: '703429', value: '769' },
    { id: '773', label: 'Ziener Produktfoto', accountNumber: '705051', value: '773' },
    { id: '772', label: 'Zalando EPDP Produktfoto HH', accountNumber: '705191', value: '772' },
    { id: "778", label: "Tommy Hilfiger Produktfoto", accountNumber: "740411", value: "778" },
    {
      id: "847",
      label: "z PDP ACC",
      accountNumber: "705230",
      value: "847",
    },
    {
      id: "848",
      label: "Mammut PF HH ",
      accountNumber: "700551",
      value: "848",
    },
    {
      id: "856",
      label: "TB International PF HH",
      accountNumber: "700451",
      value: "856",
    },
    {
      id: "859",
      label: "Marketplace Amplifier GmbH Produktfoto HH",
      accountNumber: "700452",
      value: "859",
    },
    {
      id: "849",
      label: "DEV - AI Character Creation",
      accountNumber: "709510",
      value: "849",
    },
    {
      id: "850",
      label: "DEV - AI Character Replacement",
      accountNumber: "709512",
      value: "850",
    },
    {
      id: "852",
      label: "DEV - AI Background Replacement",
      accountNumber: "709516",
      value: "852",
    },
    {
      id: "853",
      label: "DEV - AI Background Replacement",
      accountNumber: "709518",
      value: "853",
    },
    {
      id: "854",
      label: "DEV - Bust to on-Model",
      accountNumber: "709520",
      value: "854",
    },
    {
      id: "855",
      label: "DEV - AI Content Hub",
      accountNumber: "709522",
      value: "855",
    },
    {
      id: "861",
      label: "DEV - KIND",
      accountNumber: "709524",
      value: "861",
    },
  ];
  
  const handleSelectCostCenter = (selectedOption) => {
    setSelecedCostcenter(selectedOption);
  };
  
  const handleSelectCostCentertwo = (selectedOption) => {
    setSelecedCostcentertwo(selectedOption);
  };
  
  const DropdownIndicator = props => {
    return (
      props.selectProps.components.DropdownIndicator && (
        <props.selectProps.components.DropdownIndicator {...props}>
          <div style={{ width: '16px', margin: '0' }}>
            <svg version="1.1" id="Isolationsmodus" x="0px" y="0px" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
              <path xmlns="http://www.w3.org/2000/svg" d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
            </svg>
          </div>
        </props.selectProps.components.DropdownIndicator>
      )
    );
  };

  const fetchlocations = async () => {
    try {
      const response = await locationService.getAllLocations();
      if (response && response.data && response.data.locations) {
        const locationOptions = response.data.locations.map(location => ({
          value: location.id,
          label: location.name,
          city: location.city,
          short: location.short
        }));
        setLocations(locationOptions);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

  const fetchCompaniesAndTalents = async () => {
    setLoading(true);
    try {
      // Fetch companies from API
      const companiesResponse = await companyService.getAllCompanies(1, 100);
      if (companiesResponse && companiesResponse.data && companiesResponse.data.companies) {
        const companyOptions = companiesResponse.data.companies.map(company => ({
          value: company.id,
          label: company.name
        }));
        setCompanies(companyOptions);
      }

      // Fetch talents from API
      const talentsResponse = await talentService.getAllTalents(1, 100);
      if (talentsResponse && talentsResponse.data && talentsResponse.data.talents) {
        const talentOptions = talentsResponse.data.talents.map(talent => ({
          value: talent.id,
          label: talent.name,
          email: talent.email,
          // Include other necessary talent properties
        }));
        setTalents(talentOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompaniesAndTalents();
    fetchlocations();
  }, []);

  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption.value);
    setSelectedTalentdet(selectedOption);
    setSelectedTalentName(selectedOption.label);
    setSelectedTalentEmail(selectedOption.email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!selectedTalent) {
      alert("Please select a talent");
      return;
    }
    
    if (!startDate) {
      alert("Please select a start date");
      return;
    }

    setIsSubmitting(true);
    setError(null);
    
    try {
      // Prepare the booking data
      const bookingData = {
        title: title || "Talent on Hold",
        talent_id: selectedTalent,
        start_date: startDate,
        end_date: endDate || startDate,
        status: "talentOnHold", // Use the specific status for talents on hold
        
        // Optional fields
        start_time: startTime || "09:00",
        end_time: endTime || "18:00",
        kpi: kpi || 0,
        set: set.value || "On Model",
        
        // Client info as an object
        client: {
          label: client,
          value: client
        },
        
        // Position info as an object
        position: selectedPosition ? {
          label: selectedPosition.label,
          value: selectedPosition.value
        } : null,
        
        // Cost centers if selected
        cost_center1: selectedCostCenter || null,
        cost_center2: selectedCostCentertwo || null,
        
        // Additional fields
        option: bookingoption ? bookingoption.value : "1. Option",
        location: selectLocations ? selectLocations.label : "",
        studio: "",
        sonstige_info: description || "",
        
        proposed_by: localStorage.getItem("userEmail") || "",
        group: groupID || "",
        range: range || "",
        is_dummy: true
      };
      
      // Create the booking using the API
      const response = await bookingService.createBooking(bookingData);
      
      if (response && response.data && response.data.booking) {
        alert("Booking created successfully!");
        // Navigate back to the talents on hold list
        window.location.href = '/hold-talents';
      } else {
        throw new Error("Unexpected response format from API");
      }
    } catch (error) {
      console.error("Error creating booking:", error);
      setError(`Error creating booking: ${error.message}`);
      alert(`Failed to create booking: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const sortByName = () => {
    const sortedTalents = [...talents].sort((a, b) => {
      return sortOrder ? a.label.localeCompare(b.label) : b.label.localeCompare(a.label);
    });
    setTalents(sortedTalents);
    setSortOrder(!sortOrder);
  };

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
  };

  const handleFunctionChange = (e) => {
    setSelectedFunction(e.target.value);
  };

  return (
    <div className='page'>
      {loading ? (
        <div>Loading data...</div>
      ) : (
        <div>
          {error && <div style={{ color: 'red' }}>{error}</div>}
          <div className='tasks-card'>
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom:'30px'}}>
                <h2>Create Dummy Order for Talent on Hold</h2>
                <button type="submit" className='big-button' disabled={isSubmitting}>
                  {isSubmitting ? 'Creating...' : 'Create Dummy Order'}
                </button>
              </div>

              <div className='form-section' style={{maxWidth: '650px'}}>
              
              <div className='card-tasks right-card'>
                <div style={{ display: 'flex', columnGap: '14px', position: 'relative', width: '100%'}}>
                  <div style={{ flex: '1', minWidth: '0' }}>
                    <Select
                      options={talents}
                      isSearchable={true}
                      isClearable={true}
                      onChange={handleTalentChange}
                      placeholder="Select Talent"
                      styles={customStyles}
                    />
                  </div>
                  <button
                    type="button"
                    className={`big-button button-sort ${sortOrder ? 'ascending' : 'descending'}`}
                    onClick={sortByName}
                    style={{maxHeight:'50px', padding:'0px 24px', flex: '1', minWidth: '0', marginRight: '0' }}
                  >
                    Sort by name {sortOrder ? '↑' : '↓'}
                  </button>
                </div>
              </div>

              <div className='card-tasks right-card'>
                
                <div>
                  <input
                    className="inputtext"
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Talent on Hold"
                  />
                </div>
              </div>
              <div style={{ display: 'flex', columnGap: '14px', width: '100%', marginBottom:'10px' }}>
              <div className='card-tasks right-card' style={{ flex: '1', minWidth: '0' }}>

                  <input
                    className="inputdate"
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                    style={{width:'100%'}}
                  />
              </div>
              
              <div className='card-tasks right-card' style={{ flex: '1', minWidth: '0' }}>
                  <input
                    className="inputdate"
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{width:'100%'}}
                  />
              </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <Select
                    options={onmodel}
                    value={set}
                    onChange={handlesetSelect}
                    placeholder="Select Set Type"
                    styles={customStyles}
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <input
                    className="inputtext"
                    type="number"
                    value={kpi}
                    onChange={(e) => setKpi(e.target.value)}
                    placeholder="KPI"
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <Select
                    options={positions}
                    value={selectedPosition}
                    onChange={handlePostionchange}
                    placeholder="Select Position"
                    styles={customStyles}
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <Select
                    options={bookingoptions}
                    value={bookingoption}
                    onChange={handlebookingOption}
                    placeholder="Select Option"
                    styles={customStyles}
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <input
                    className="inputtext"
                    type="text"
                    value={client}
                    onChange={(e) => setClient(e.target.value)}
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <Select
                    options={locations}
                    value={selectLocations}
                    onChange={setSelectedLocations}
                    placeholder="Select Location"
                    styles={customStyles}
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <textarea
                    className="inputtext"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ height: '100px' }}
                    placeholder="Description/SonstigeInfo"
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <Select
                    options={constcenter1}
                    value={selectedCostCenter}
                    onChange={handleSelectCostCenter}
                    placeholder="Select Cost Center 1"
                    styles={customStyles}
                  />
                </div>
              </div>

              <div className='card-tasks right-card'>
                <div>
                  <Select
                    options={constcenter2}
                    value={selectedCostCentertwo}
                    onChange={handleSelectCostCentertwo}
                    placeholder="Select Cost Center 2"
                    styles={customStyles}
                  />
                </div>
              </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateDummyOrder;